import { SwapOutlined } from '@ant-design/icons';
import { Card, Timeline, Typography } from 'antd';
import moment from 'moment';

interface ApplicantStageMovimentationTimelineProps {
  recruiterName: string;
  createdDate: string;
  fromStage: string;
  toStage: string;
  opportunityTitle: string;
}

const ApplicantStageMovimentationTimeline = ({
  recruiterName,
  createdDate,
  fromStage,
  opportunityTitle,
  toStage,
}: ApplicantStageMovimentationTimelineProps) => {
  return (
    <Timeline.Item dot={<SwapOutlined />}>
      <Card>
        <Typography.Paragraph>
          <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
          <br />
          <Typography.Text>
            <Typography.Text strong>{recruiterName} </Typography.Text>
            movimentou o(a) candidato(a) da etapa{' '}
            <Typography.Text strong>{fromStage}</Typography.Text> para a etapa{' '}
            <Typography.Text strong>{toStage}</Typography.Text> na vaga{' '}
            <Typography.Text strong>{opportunityTitle}</Typography.Text>
          </Typography.Text>
        </Typography.Paragraph>
      </Card>
    </Timeline.Item>
  );
};

export default ApplicantStageMovimentationTimeline;
